var _path, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.86,3.69h-.65a2.22,2.22,0,0,0-1.58.66L6,7H4.23A2.24,2.24,0,0,0,2,9.24v5.52A2.24,2.24,0,0,0,4.23,17H6l2.67,2.66a2.22,2.22,0,0,0,1.58.66h.65a2.24,2.24,0,0,0,2.23-2.24V5.93A2.24,2.24,0,0,0,10.86,3.69Zm0,14.35h-.63L7.57,15.38A2.3,2.3,0,0,0,6,14.73l-1.72,0,0-5.49H6a2.25,2.25,0,0,0,1.58-.65L10.21,6h.62Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "22 9.78 20.43 8.21 18.21 10.43 15.99 8.21 14.42 9.78 16.64 12 14.42 14.22 15.99 15.79 18.21 13.57 20.43 15.79 22 14.22 19.78 12 22 9.78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteAll);
export default __webpack_public_path__ + "static/media/mute-all.159e858e7c9c215d5b91ae2f4cc2cfeb.svg";
export { ForwardRef as ReactComponent };